import React from "react";
import { Snackbar } from "@mui/base";
import { Alert } from "@mui/material";

export const ToastAlert = ({ show, setShow, type, message, loading = false }) => {
  // Se estiver carregando/processando (tipo "info" com loading), não fechar automaticamente
  // Para erros, aumentar o tempo de exibição
  // Para outros tipos sem loading, usar timeout padrão
  const shouldAutoHide = !loading && type !== "info";
  const autoHideDuration = type === "error" ? 15000 : 5000; // 15 segundos para erros, 5 para outros
  
  return (
    <Snackbar
      open={show}
      autoHideDuration={shouldAutoHide ? autoHideDuration : null} // null = não fecha automaticamente
      onClose={() => setShow(false)}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      style={{
        position: "fixed",
        top: "10%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 9999, // Garantir que apareça acima de tudo
      }}
    >
      <Alert
        variant="filled"
        onClose={() => setShow(false)}
        severity={type}
        sx={{ 
          width: "100%",
          maxWidth: "600px", // Limitar largura para melhor legibilidade
          whiteSpace: "pre-wrap", // Permitir quebra de linha se necessário
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
